"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_use_1 = require("react-use");
const react_visibility_sensor_1 = tslib_1.__importDefault(require("react-visibility-sensor"));
const reactstrap_1 = require("reactstrap");
const hooks_1 = require("../../hooks");
const react_2 = require("@osmosys/react");
const Inner_1 = require("./Inner");
exports.OsmosysLogTerminal = props => {
    const { logs, status, showSpinner, run } = props;
    const { ref, isFullscreen, toggleFullscreen } = hooks_1.useFull();
    const [userHasScrollControl, toggleUserScrollControl] = react_use_1.useToggle(false);
    const [bottomIsVisible, changeBottomIsVisible] = react_use_1.useToggle(true);
    const scrollContainer = react_1.default.useRef(null);
    const footer = react_1.default.useRef(null);
    const innerContainer = react_1.default.useRef(null);
    const scrollToBottom = () => {
        if (userHasScrollControl) {
            toggleUserScrollControl(false);
        }
        if (scrollContainer && scrollContainer.current) {
            scrollContainer.current.scrollTo({
                left: 0,
                top: innerContainer.current.offsetHeight,
            });
        }
    };
    const onScroll = () => {
        if (scrollContainer && scrollContainer.current) {
            if (innerContainer.current.offsetHeight <
                scrollContainer.current.scrollTop + scrollContainer.current.offsetHeight) {
                toggleUserScrollControl(false);
            }
            else {
                toggleUserScrollControl(true);
            }
        }
    };
    react_use_1.useEvent('scroll', react_1.default.useCallback(onScroll, []), scrollContainer.current);
    react_use_1.useDebounce(() => {
        if (!userHasScrollControl) {
            if (scrollContainer && scrollContainer.current) {
                scrollContainer.current.scrollTo({
                    left: 0,
                    top: innerContainer.current.offsetHeight,
                });
            }
        }
    }, 2, [logs]);
    return (react_1.default.createElement("div", { style: {
            fontSize: 14,
            height: 300,
            position: 'relative',
        }, className: "d-flex flex-row position-relative", ref: ref },
        react_1.default.createElement("div", { style: {
                height: '100%',
                overflowY: 'auto',
                padding: '15px 20px',
                position: 'relative',
            }, className: "bg-dark text-white flex-grow-1", ref: scrollContainer },
            react_1.default.createElement("div", { ref: innerContainer },
                react_1.default.createElement(Inner_1.OsmosysLogTerminalInner, { showSpinner: showSpinner, logs: logs, status: status, run: run })),
            status === 'error' && (react_1.default.createElement("div", { className: "m-1" },
                react_1.default.createElement(react_2.OsmosysAlert, { floatBottom: false }, "This conversion ended in an error"))),
            react_1.default.createElement(react_visibility_sensor_1.default, { onChange: isVisible => {
                    if (isVisible !== bottomIsVisible) {
                        changeBottomIsVisible(isVisible);
                    }
                    if (userHasScrollControl && isVisible) {
                        toggleUserScrollControl(false);
                    }
                } },
                react_1.default.createElement("br", { ref: footer, className: "w-100" }))),
        react_1.default.createElement("div", { className: "m-1 position-absolute d-flex flex-column justify-content-between", style: {
                bottom: 0,
                right: 0,
                top: 0,
            } },
            react_1.default.createElement(react_2.OsmosysTooltip, { label: isFullscreen ? 'Close full screen' : 'Open in full screen' },
                react_1.default.createElement(reactstrap_1.Button, { onClick: () => toggleFullscreen(), type: "button", color: "dark", size: "sm rounded-circle" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isFullscreen ? pro_solid_svg_icons_1.faTimes : pro_light_svg_icons_1.faExpandAlt, style: {
                            height: '1em',
                            width: '1em',
                        } }))),
            userHasScrollControl && (react_1.default.createElement(reactstrap_1.Button, { onClick: () => {
                    scrollToBottom();
                }, type: "button", color: "dark", size: "sm rounded-circle", className: "align-self-end" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faChevronDown, style: {
                        height: '1em',
                        width: '1em',
                    } }))))));
};
//# sourceMappingURL=index.js.map